import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { OriginEnum } from '@sc/pas-common';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'sc-old-car-quotation',
  templateUrl: './old-car-quotation.component.html',
  styleUrls: ['./old-car-quotation.component.scss']
})
export class OldCarQuotationComponent implements OnInit {

  public iframeState: any;
  isLoading = false;
  iframeSource: string;
  polizaURL: string;
  private state$: any;
  insuring = false;
  public token: string | null;
  loadingPolicy: boolean;
  @ViewChild('polizaIframe', { static: true }) polizaIframe: any;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private router: Router) { }

  ngOnInit() {
    this.setRouteIframe();
    this.state$ = new Subject();
    this.onMessageReceived().subscribe((val: any) => {
      const state = val.state;
      if (state) {
        this.iframeState = state;
        this.insuring = state !== 'closed';
        this.isLoading = false;
        if (!this.changeDetector['destroyed']) {
          this.changeDetector.markForCheck();
        }
      }
      if (val.hasOwnProperty('newQuotation')) {
        this.isLoading = true;
        const hash = localStorage.getItem('hash');
        const hashParameter = hash ? `&p=${hash}` : '';
        const categoryParameter = val.categoryKey ? `&categoryKey=${val.categoryKey}` : '';
        const iframeSource = `${this.polizaURL}#/auth?tk=${this.token}&fromHome=true${hashParameter}&new=true${categoryParameter}`;
        this.iframeSource = iframeSource;
      }
      if (val.hasOwnProperty('closeLateralMenu')) {
        this.isLoading = false;
      }
      if (val.action === 'dismiss') {
        if (val.openViewPolicy) {
          this.router.navigate([`./detalle-poliza/ver/${val.policyNumber}/${OriginEnum.briefcaseList}`])
        }
        this.closePoliza();
      }
      if (val.hasOwnProperty('open')) {
        window.parent.postMessage({ loading: true }, '*');
        const hash = localStorage.getItem('hash');
        this.iframeSource = this.polizaURL + '#/auth?tk=' + this.token + '&fromHome=true' + (hash ? '&p=' + hash : '') +
          (val.open ? '&id=' + val.open : '&new=true') + (val.idLite ? '&idLite=' + val.idLite : '');
      }
      if (val.hasOwnProperty('opportunityId')) {
        this.buildIframeUrl(val);
    }
    });

    this.token = localStorage.getItem('tk');
    if (this.token) {
      const reset = localStorage.getItem('reset');
      if (reset) {
        localStorage.removeItem('reset')
      }
    }
    this.setIframeObserver(this.polizaIframe);
  }

  buildIframeUrl(value) {
    window.parent.postMessage({ loading: true }, '*');
    const hash = localStorage.getItem('hash');
    this.iframeSource = `${this.polizaURL}#/auth?tk=${this.token}&fromHome=true${(hash ? '&p=' + hash : '')}${(value.open ? '&id=' + value.open : '&new=true')}${(value.opportunityId ? '&opportunityId=' + value.opportunityId : '')}${(value.branchOffice ? '&branchOffice=' + value.branchOffice : '')}${(value.number ? '&number=' + value.number : '')}${(value.organizerNumber ? '&organizerNumber=' + value.organizerNumber : '')}`;
}

  onPolizaLoaded() {
    if (!this.changeDetector['destroyed']) {
      this.changeDetector.markForCheck();
    }
  }

  handleNewQuotation() {
    this.isLoading = true;
    window.parent.postMessage({ openSelector: true, insuranceCoreNameByUser: 'DYNAMO', openMenu: true }, '*');
  }

  setRouteIframe() {
    this.polizaURL = environment.server.web.poliza;
    this.iframeSource = this.polizaURL;
  }

  onMessageReceived() {
    return new Observable(observer => {
      window.addEventListener('message', function (event) {
        if (typeof (event.data) !== 'undefined') {
          observer.next(event.data);
        }
      })
    });
  }

  closePoliza() {
    this.state$.next({ state: 'closed' });
    this.iframeState = 'closed';
    setTimeout(() => {
      this.insuring = false;
      this.loadingPolicy = false;
      this.iframeSource = this.polizaURL;
      this.isLoading = false;
      if (!this.changeDetector['destroyed']) {
        this.changeDetector.detectChanges();
      }
    }, 2000)
  }

  setIframeObserver(el) {
    if (el) {
      const element = el.nativeElement;
      const observer = new MutationObserver((event) => {
        if (element.classList.contains('mid') || element.classList.contains('full') || element.classList.contains('full-cover')) {
          this.isLoading = false;
        }
      });
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false
      })
    }
  }
}
